/* eslint-disable yola/import/extensions */

import combineReducers from 'combine-reducers';

import composeReducer from './utils/helpers/compose-reducer';
import reduceArrayItems from './utils/helpers/reduce-array-items';
import clipboard from './clipboard';
import config from './config';
import customization from './customization';
import history from './history';
import saving from './saving';
import site from './site';
import view from './view';
import extensions from './extensions';
import blocks from './blocks';
import interrupter from './interrupter';
import dialogs from './dialogs';
import assets from './assets';
import globals from './globals';
import integration from './integration';
import i18n from './i18n';
import blockTemplates from './block-templates';
import siteLocales from './site-locales';
import siteDependencies from './site-dependencies';
import template from './template';
import constraints from './constraints';
import readOnly from './read-only';

export default {
  ws: combineReducers({
    template: combineReducers({
      meta: combineReducers({
        blockCategories: blocks.reducers.categories,
        blocks: composeReducer(
          blocks.reducers.blocks,
          reduceArrayItems(
            composeReducer(
              blocks.reducers.blockHTML,
              blocks.reducers.blockPreview,
              blocks.reducers.blockVariationHTML,
              blocks.reducers.blockVariationPreview
            )
          )
        ),
        blockTemplates: blockTemplates.reducers.blockTemplates,
        constraints: constraints.reducers.constraints,
        dependencies: siteDependencies.reducers.dependencies,
        globals: composeReducer(
          globals.reducers.globals,
          reduceArrayItems(globals.reducers.globalHTML)
        ),
        designAutomation: template.reducers.designAutomation,
        extensions: extensions.reducers.extensionConfigurations,
        pageTemplates: composeReducer(
          template.reducers.pageTemplates,
          reduceArrayItems(template.reducers.pageTemplateHTML)
        ),
        translations: template.reducers.metaTranslations,
        emptyPage: template.reducers.emptyPage,
        pageContainer: template.reducers.pageContainerSelector,
        socialIcons: template.reducers.socialIcons,
        variables: template.reducers.variables,
        supportedBlockCategoriesForRegeneration:
          template.reducers.supportedBlockCategoriesForRegeneration,
        customization: customization.reducers.customization,
      }),
      buildSlug: template.reducers.buildSlug,
    }),
    site: combineReducers({
      id: site.reducers.siteId,
      name: site.reducers.siteName,
      session: site.reducers.session,
      properties: site.reducers.siteProperties,
      ownerId: site.reducers.ownerId,
      updatedAt: site.reducers.updatedAt,
      lastAppliedMigrationId: site.reducers.lastAppliedMigrationId,
      meta: combineReducers({
        multilingual: site.reducers.multilingual,
        activePage: site.reducers.activePage,
        pages: composeReducer(
          site.reducers.pages,
          reduceArrayItems(
            composeReducer(
              site.reducers.pageSettings,
              site.reducers.pageHTML,
              site.reducers.pageHasGlobals,
              site.reducers.pageUsedBlocks,
              site.reducers.usedCustomColors
            )
          )
        ),
        currentTheme: customization.reducers.currentTheme,
        customization: customization.reducers.siteCustomization,
        mainLocale: siteLocales.reducers.mainLocale,
        settings: site.reducers.settings,
        onlinestore: combineReducers({
          cleanUrlsEnabled: site.reducers.cleanUrlsEnabled,
        }),
        redirects: site.reducers.redirects,
        integrations: site.reducers.integrations,
      }),
    }),
    view: combineReducers({
      updatedAt: view.reducers.updatedAt,
      mappedHTML: view.reducers.mappedHTML,
      selectedElement: view.reducers.selectedElement,
      focusedElement: view.reducers.focusedElement,
      hoveredElement: view.reducers.hoveredElement,
      scrollPosition: view.reducers.scrollPosition,
      isScrolling: view.reducers.isScrolling,
      selection: view.reducers.selection,
      status: combineReducers({
        loaded: view.reducers.isLoaded,
        disabled: view.reducers.isDisabled,
      }),
    }),
    clipboard: combineReducers({
      data: clipboard.reducers.clipboardData,
    }),
    config: combineReducers({
      service: config.reducers.serviceConfig,
    }),
    integration: combineReducers({
      settings: integration.reducers.settings,
    }),
    extensions: composeReducer(extensions.reducers.extensions),
    supportedLocales: siteLocales.reducers.supportedLocales,
    history: history.reducers.history,
    saving: combineReducers({
      error: saving.reducers.error,
      status: saving.reducers.status,
      assets: assets.reducers.assets,
    }),
    interrupter: combineReducers({
      interruptions: interrupter.reducers.interruptions,
      status: interrupter.reducers.status,
    }),
    locale: i18n.reducers.locale,
    readOnly: readOnly.reducers.readOnly,
    dialogs: dialogs.reducers.dialog,
  }),
};
